import LoadingSpinner from "./LoadingSpinner";

export default function Loading() {
    return (
        <div className="container ms-auto h-100">
            <LoadingSpinner />
        </div>
    )
}
